import React, { useState, createContext, useContext, useCallback } from 'react';

const AssetLoadingContext = createContext();

export const useAsset = (src) => {
    const { onAssetLoad } = useContext(AssetLoadingContext);
    return { onLoad: () => onAssetLoad(src) };
};

export const AssetLoader = ({ assets, children }) => {
    const [loadedAssets, setLoadedAssets] = useState({});

    const handleAssetLoad = useCallback((src) => {
        setLoadedAssets(prev => ({ ...prev, [src]: true }));
    }, []);

    const allAssetsLoaded = Object.keys(loadedAssets).length >= assets.length;

    return (
        <AssetLoadingContext.Provider value={{ onAssetLoad: handleAssetLoad }}>
            {children(allAssetsLoaded)}
        </AssetLoadingContext.Provider>
    );
};
